// @format

// The reply drawer renders each reply with its stored preview and a data-body-url while the whole
// message is still being fetched from the mailbox (EmailResponsesController#inbox_reply_body).
// Swaps the full message in; on failure the preview stays.
export function loadReplyBodies($root: JQuery) {
  $root.find(".inbox-reply-html[data-body-url]").each(function() {
    const $body = $(this);
    const url = String($body.data("body-url"));
    $body.removeAttr("data-body-url");

    $.get(url)
      .done((html: string) => {
        if (html.trim()) $body.find(".inbox-reply-content").html(html);
      })
      .always(() => {
        $body.removeClass("loading").removeAttr("aria-busy");
        $body.find(".inbox-reply-loading").remove();
      });
  });
}
